export const ADEL_URL = 'https://www.adel-sante.fr/medecin/'
